const normalize = (value) => String(value || "").trim();

const unique = (values) => Array.from(new Set(values.map(normalize).filter(Boolean)));

const PROFILES = {
  soupMeal: [
    ["Wholegrain Dinner Rolls", "Garden Salad"],
    ["Vegetable Sticks with Dip", "Mixed Greens"],
  ],
  breakfast: [
    ["Fresh Fruit Plate", "Roasted Breakfast Tomatoes"],
    ["Vegetable Sticks with Dip", "Fresh Fruit Plate"],
  ],
  dinnerSalad: [
    ["Tomato Soup", "Roasted Vegetables"],
    ["Vegetable Soup", "Fresh Fruit Plate"],
  ],
  texMex: [
    ["Roasted Red Pepper Soup", "Corn on the Cob"],
    ["Vegetable Sticks with Dip", "Tomato Cucumber Salad"],
  ],
  asian: [
    ["Carrot Ginger Soup", "Cucumber Salad"],
    ["Vegetable Soup", "Roasted Broccoli"],
  ],
  curry: [
    ["Carrot Ginger Soup", "Cucumber Salad"],
    ["Roasted Red Pepper Soup", "Mixed Greens"],
  ],
  mediterranean: [
    ["Roasted Red Pepper Soup", "Greek Salad"],
    ["Tomato Soup", "Roasted Vegetables"],
  ],
  pastaPizza: [
    ["Vegetable Soup", "Caesar Salad"],
    ["Garlic Bread", "Mixed Greens"],
  ],
  riceBowl: [
    ["Vegetable Soup", "Cucumber Salad"],
    ["Carrot Ginger Soup", "Steamed Green Beans"],
  ],
  fish: [
    ["Vegetable Soup", "Mixed Greens"],
    ["Tomato Soup", "Roasted Broccoli"],
  ],
  sandwich: [
    ["Tomato Soup", "Coleslaw"],
    ["Vegetable Soup", "Apple Slaw"],
  ],
  pieBake: [
    ["Vegetable Soup", "Steamed Green Beans"],
    ["Tomato Soup", "Garden Salad"],
  ],
  roastStew: [
    ["Carrot Ginger Soup", "Roasted Vegetables"],
    ["Vegetable Soup", "Steamed Green Beans"],
  ],
  poultry: [
    ["Tomato Soup", "Garden Salad"],
    ["Butternut Squash Soup", "Steamed Green Beans"],
  ],
  vegetarian: [
    ["Tomato Soup", "Mixed Greens"],
    ["Vegetable Soup", "Roasted Vegetables"],
  ],
};

const hasAny = (name, terms) => terms.some((term) => name.includes(term));

const profileFor = (dishName) => {
  const name = normalize(dishName).toLowerCase();

  if (hasAny(name, ["soup bowl", "chowder", "minestrone dinner", "pasta e fagioli", "grilled cheese and tomato soup"])) return "soupMeal";
  if (hasAny(name, ["breakfast-for-dinner", "pancakes", "french toast", "frittata", "omelette", "shakshuka", "corned beef hash"])) return "breakfast";
  if (hasAny(name, ["salad dinner"])) return "dinnerSalad";
  if (hasAny(name, ["taco", "fajita", "burrito", "quesadilla", "enchilada", "nacho", "tortilla", "mexican", "one-pot taco"])) return "texMex";
  if (hasAny(name, ["stir-fry", "fried rice", "teriyaki", "honey soy", "sweet and sour", "orange chicken", "sesame chicken", "mongolian", "korean", "bibimbap", "ramen", "udon", "pad thai", "peanut noodles"])) return "asian";
  if (hasAny(name, ["curry", "dahl", "tikka", "madras", "butter chicken"])) return "curry";
  if (hasAny(name, ["greek", "gyros", "moussaka", "ratatouille", "niçoise", "mediterranean", "falafel", "hummus", "halloumi", "moroccan", "caprese", "stuffed tomatoes", "couscous"])) return "mediterranean";
  if (hasAny(name, ["pasta", "spaghetti", "macaroni", "lasagna", "ziti", "gnocchi", "pizza", "calzone", "ragu", "orzo", "alfredo", "bolognese", "chili mac"])) return "pastaPizza";
  if (hasAny(name, ["rice", "risotto", "bowl", "paella", "jambalaya", "poke", "sushi-style"])) return "riceBowl";
  if (hasAny(name, ["sandwich", "burger", "wrap", "sloppy", "toasties", "club sandwich", "panini", "sub", "cheesesteak", "french dip", "reuben", "pita plate", "croque monsieur"])) return "sandwich";
  if (hasAny(name, ["dublin coddle"])) return "roastStew";
  if (hasAny(name, ["fish", "salmon", "baked cod", "tilapia", "shrimp", "tuna", "seafood", "clam"])) return "fish";
  if (hasAny(name, ["pie", "casserole", "bake", "traybake", "stuffed pepper", "stuffed zucchini", "dumpling", "cauliflower cheese", "potato bake", "loaded baked potato", "loaded sweet potato", "stuffed bell pepper"])) return "pieBake";
  if (hasAny(name, ["roast", "stew", "goulash", "bourguignon", "coddle", "meatloaf", "shepherd", "steak", "pork chop", "beef tips", "sausage", "bratwurst", "kielbasa", "meatball", "toad in the hole", "bangers and mash", "beef chili", "beef stroganoff", "pork schnitzel", "cabbage rolls"])) return "roastStew";
  if (hasAny(name, ["chicken", "turkey", "duck"])) return "poultry";
  return "vegetarian";
};

export function buildEnglishMenus(legacyMenus = [], targetCount = 500) {
  const originalMains = unique(legacyMenus.map((menu) => menu.anaYemek));
  const mainSchedule = originalMains.slice(0, Math.min(originalMains.length, targetCount));

  for (let index = 0; mainSchedule.length < targetCount; index += 1) {
    mainSchedule.push(originalMains[index % originalMains.length]);
  }

  const usageByMain = new Map();

  return mainSchedule.map((anaYemek, index) => {
    const variant = usageByMain.get(anaYemek) || 0;
    usageByMain.set(anaYemek, variant + 1);
    const pairingProfile = profileFor(anaYemek);
    const pairings = PROFILES[pairingProfile];
    const [corba, salata] = pairings[variant % pairings.length];

    return {
      id: index + 1,
      anaYemek,
      corba,
      salata,
      pairingProfile,
      variant: variant + 1,
      culture: "en",
    };
  });
}
